import * as React from 'react';
import * as moment from 'moment';

import { IEvent } from '../custom/classes/event';
import { ICalendarState, IMonth, CalendarViewMode, CalendarDeviceMode } from '../classes/calendar';
import { ICalendarAppText } from '../custom/classes/calendar-text';

import { connect } from 'react-redux';

import { ICalendarAppState } from '../redux-state';

import CalendarViewToggleView from 'calendar-view-toggle.view';
import { setToGrid, setToList } from '../redux-state/actions/calendar-settings.actions';
import { scrollToMonth } from '../../calendar/helpers/scroll-to-month';

interface ICalendarViewTogglePropsExternalProps {

}

interface StateToProps {
    text: ICalendarAppText
    calendarMode: CalendarViewMode;
    calendarDeviceMode: CalendarDeviceMode;
    currentDate: moment.Moment;
    startMonth: moment.Moment;
}

interface DispatchToProps {
    setToGrid: (currentDate?: moment.Moment, startDate?: moment.Moment) => void;
    setToList: (currentDate?: moment.Moment, startDate?: moment.Moment) => void;
}

export type CalendarViewToggleProps = ICalendarViewTogglePropsExternalProps & StateToProps & DispatchToProps;

export class CalendarViewToggleBase extends React.Component<CalendarViewToggleProps, any> {
    render() {
        return (
            <>
                {
                    this.props.calendarDeviceMode === CalendarDeviceMode.DESKTOP ? <CalendarViewToggleView {...this.props} /> : null
                }
            </>
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: ICalendarViewTogglePropsExternalProps): StateToProps {
    return {
        text: state.calendarText,
        calendarMode: state.calendarSettings.calendarViewMode,
        calendarDeviceMode: state.calendarSettings.calendarDeviceMode,
        currentDate: state.calendar.currentDate,
        startMonth: state.calendar.startDate
    }
}

function jumpToMonth(currentDate: moment.Moment, startDate: moment.Moment) {
    // Don't scroll if loaded month and the start month of Calendar are same
    if (currentDate.month() != startDate.month()) {
        let updateMonth = window.setInterval(() => {
            if (scrollToMonth(currentDate))
                window.clearInterval(updateMonth);
        }, 500);
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        setToGrid: (currentDate?: moment.Moment, startDate?: moment.Moment) => {
            dispatch(setToGrid())
            if (currentDate != undefined)
                jumpToMonth(currentDate, startDate)
        },
        setToList: (currentDate?: moment.Moment, startDate?: moment.Moment) => {
            dispatch(setToList())
            if (currentDate != undefined)
                jumpToMonth(currentDate, startDate)
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(CalendarViewToggleBase);